import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SimpleSelectMenu } from './SimpleSelectMenu';
import { SimpleSelectOption } from './SimpleSelectOption';
import { SimpleSelectTrigger } from './SimpleSelectTrigger';
import styles from '@dtsl/css-simple-select/dist/index.module.css';
const SimpleSelect = props => {
  const {
    children,
    isOpen = false,
    className = '',
    id = ''
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(isOpen);
  const triggerRef = useRef(null);
  useEffect(() => {
    if (isMenuOpen !== isOpen) {
      setIsMenuOpen(isOpen);
    }
  }, [isOpen]);
  const simpleSelectClasses = classNames({
    [styles['sib-simple-select']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("div", {
    className: simpleSelectClasses,
    id: id
  }, React.Children.map(children, (child, index) => {
    return /*#__PURE__*/React.cloneElement(child, {
      id,
      key: index,
      isMenuOpen,
      setIsMenuOpen,
      ref: triggerRef
    });
  }));
};
SimpleSelect.Trigger = SimpleSelectTrigger;
SimpleSelect.Menu = SimpleSelectMenu;
SimpleSelect.Option = SimpleSelectOption;
SimpleSelect.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  className: PropTypes.string
};
export default SimpleSelect;